module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "also"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_vm._v("Also by Kyle Ward")])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "also1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("History Lessons: How Textbooks from Around the World Portray U.S. History")]), _vm._v(" (with Dana Lindaman)")]), _vm._v(" "), _c('p', {
    staticClass: "also2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In the Shadow of Glory: The Thirteenth Minnesota in the Spanish-American and Philippine-American Wars, 1898–1899")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fac3696","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Also.vue
// module id = 57
// module chunks = 0